import { useIntl } from 'react-intl';
import { Stack, Typography } from '@rossum/ui/material';
import { useScoreThresholdSlider } from '../../../../../containers/Queue/containers/AutomationDetail/useScoreThresholdSlider';

type LegacyThresholdSliderProps = {
  scoreThreshold: number;
  setScoreThreshold: (value: number) => void;
  disabled?: boolean;
};

export const LegacyThresholdSlider = ({
  scoreThreshold,
  setScoreThreshold,
  disabled,
}: LegacyThresholdSliderProps) => {
  const intl = useIntl();

  const { Component: ScoreThresholdSlider } = useScoreThresholdSlider({
    defaultValue: scoreThreshold,
    thresholdValue: scoreThreshold,
    onChange: value => {
      if (value === null) return;
      setScoreThreshold(value);
    },
    sliderProps: {
      disabled,
    },
  });

  return (
    <Stack spacing={4} useFlexGap>
      <Stack spacing={1} useFlexGap>
        <Typography variant="h5">
          {intl.formatMessage({
            id: 'containers.settings.queues.queue.automation.legacySettings.thresholds.title',
          })}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {intl.formatMessage({
            id: 'containers.settings.queues.queue.automation.legacySettings.thresholds.description',
          })}
        </Typography>
      </Stack>
      {ScoreThresholdSlider}
    </Stack>
  );
};
